import { render, staticRenderFns } from "./PromoView.vue?vue&type=template&id=d6129748"
import script from "./PromoView.vue?vue&type=script&lang=js"
export * from "./PromoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports